import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'
import { IComposedReportFilters } from 'legacy/lut/components/widgets/public/partner360/composedReport/models'

import { CrudStore } from 'core/types/crudStore'

import { composedReportFiltersForm } from '../configs'
import { TSaveMethod } from '../models'

interface ISaveFilter extends Partial<IComposedReportFilters> {
  method: TSaveMethod
}

export const saveFilter = async ({ Name, Filters, EntryId, method }: ISaveFilter) => {
  const crud = CrudStore.get(CrudStoreItemPartner360.JBPComposedReportFilters)
  return crud[method](composedReportFiltersForm, [{ Name, Filters, EntryId }])
}
